import { Routes } from '@angular/router';
import { OurShowroomComponent } from './container/our-showroom.component';

export const OUR_SHOWROOM_ROUTES: Routes = [
    {
        path: '',
        component: OurShowroomComponent,
    },
];
